import React, { FC } from 'react'
import { useAppDispatch } from 'Src/hooks/useAppDispatch'
import { i18n, IconComponent, UITypes } from 'LibNeo'
import {
	notificationListSlice,
	NotificationPopupModel,
	notificationPopupSlice,
	NOTIFICATION_TYPE,
} from 'Modules'
import {
	NotificationFooter,
	NotificationBody,
	NotificationHeader,
	NotificationItem,
	NotificationTitle,
	DisplayFlex,
	NotificationWrapper,
	NotificationText,
} from './styled'

interface ComponentProps {
	item: NotificationPopupModel
	index: number
}

const actions = {
	removeNotification: notificationPopupSlice.actions.remove,
	clickMessageGroup: notificationListSlice.actions.clickViewMessage,
}

export const NotificationItemComponent: FC<ComponentProps> = ({ item, index }) => {
	const { removeNotification, clickMessageGroup } = useAppDispatch(actions)

	const renderIcon = (item: NotificationPopupModel) => {
		switch (item?.type) {
			case NOTIFICATION_TYPE.ERROR:
				return <IconComponent name="alert-circle" type={UITypes.DANGER} />
			case NOTIFICATION_TYPE.INFO:
				return <IconComponent name="info" type={UITypes.BLUE} />
			case NOTIFICATION_TYPE.SUCCESS:
				return <IconComponent name="check-circle" type={UITypes.PRIMARY} />
			default:
				return <IconComponent name="check-circle" type={UITypes.PRIMARY} />
		}
	}

	return (
		<NotificationWrapper
			key={`${item?.title}_${index}`}
			onClick={
				item?.groupMenu
					? () => {
							clickMessageGroup(item?.groupMenu)
							removeNotification(index)
					  }
					: null
			}
		>
			<NotificationItem>
				<NotificationHeader>
					<DisplayFlex>
						<div>{renderIcon(item)}</div>
						<NotificationText>
							<NotificationTitle>{i18n(item?.title)}</NotificationTitle>
							<NotificationBody hasTitle={!!item?.title}>{item?.body}</NotificationBody>
						</NotificationText>
					</DisplayFlex>
					{item?.close && (
						<div>
							<IconComponent
								name="close"
								type={UITypes.PASSIVE}
								onClick={(e) => {
									e.stopPropagation()
									e.preventDefault()
									removeNotification(index)
								}}
							/>
						</div>
					)}
				</NotificationHeader>
				<NotificationFooter>{item?.footer}</NotificationFooter>
			</NotificationItem>
		</NotificationWrapper>
	)
}
